import { render, staticRenderFns } from "./MedicationEntries.vue?vue&type=template&id=1c8fcc7b&scoped=true"
import script from "./MedicationEntries.vue?vue&type=script&lang=js"
export * from "./MedicationEntries.vue?vue&type=script&lang=js"
import style0 from "./MedicationEntries.vue?vue&type=style&index=0&id=1c8fcc7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8fcc7b",
  null
  
)

export default component.exports